import React from 'react';
import './style.css';
const Index = ({ type, title, msg }) => {
    return (
        <div className="notification_msg">
            <h4 className={`notification_msg_heading bg-${type === 'blue' ? 'blue' : 'orange'}`}>
                {type === 'blue' ? 'Imporvement' : 'Operational And Catalogue'}
            </h4>
            <p className="notification_msg_msg">
                <strong>{title}</strong>
                <span>{msg}</span>
            </p>
        </div>
    );
};

export default Index;
